import { render, staticRenderFns } from "./maintenanceTasksAdd.vue?vue&type=template&id=60e0fef0&scoped=true&"
import script from "./maintenanceTasksAdd.vue?vue&type=script&lang=js&"
export * from "./maintenanceTasksAdd.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceTasksAdd.vue?vue&type=style&index=0&id=60e0fef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0fef0",
  null
  
)

export default component.exports